import { css } from '@emotion/react'
import styled from '@emotion/styled'
import noise from 'assets/images/noise.png'
import { unifiedColors } from 'styles/colors'
import { theme, themeUtils } from 'styles/theme'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 106px;

  ${themeUtils.maxWidth.md} {
    height: auto;
    margin: 0 0 64px;
  }

  ${themeUtils.maxWidth.sm} {
    padding: 0;
    margin: 0 0 32px;
  }
`

interface EventSectionContentProps {
  $hasGroup: boolean
}

export const EventSectionContentFirst = styled.div<EventSectionContentProps>`
  width: 100%;
  padding: 12px 0;
  position: sticky;
  top: ${({ $hasGroup }) => ($hasGroup ? 50 : 0)}px;
  background-color: ${unifiedColors.surface.secondary};
  z-index: 90;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.03;
    background-image: url(${noise.src});
  }

  ${themeUtils.maxWidth.md} {
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin-bottom: 12px;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const EventContentGrid = styled.div`
  width: 100%;
  ${themeUtils.minWidth.md} {
    display: grid;
    grid-template-columns: 8fr 5fr;
  }
`

interface EventRightContentProps {
  $hasGroup: boolean
}

export const EventRightContainer = styled.div<EventRightContentProps>`
  display: flex;
  flex-direction: column;
  gap: 20px 0;
  position: sticky;
  top: ${({ $hasGroup }) => 94 + ($hasGroup ? 50 : 0)}px;
  max-height: 85vh;
  ${themeUtils.maxWidth.md} {
    display: none;
  }
`

export const EventRightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-left: 20px;
  border-radius: 20px;
  background-color: ${unifiedColors.surface.subdued};
  padding: 34px 32px;
  height: fit-content;
  max-height: 85%;
  overflow-y: auto;
  min-width: 400px;
  z-index: 1;
`

export const EventCourse = styled.div`
  font-weight: ${themeUtils.fontWeights.regular};
  padding: 34px 32px;
  justify-content: space-between;
  border-radius: 20px;
  background-color: ${unifiedColors.surface.subdued};

  ${themeUtils.maxWidth.sm} {
    padding: 17px 15px;
  }
`

export const ContentFilterButton = styled.div`
  margin-top: 19px;
`

interface FilterButtonProps {
  $category: string
  $selectedCategory: string | null
}

export const FilterButton = styled.button<FilterButtonProps>`
  background: ${theme.palette.surface.subdued};
  border: none;
  padding: 12px 16px;
  border-radius: 52px;
  font-weight: ${themeUtils.fontWeights.semiBold};
  ${({ $category, $selectedCategory }) =>
    ($selectedCategory === null && $category === 'all') ||
    $selectedCategory === $category
      ? css`
          color: ${unifiedColors.label.onPurple};
          background-color: ${unifiedColors.button.tertiary.default};
          font-weight: bold;
        `
      : css`
          color: ${unifiedColors.label.subdued};
          background-color: transparent;
        `}
  cursor: pointer;

  ${themeUtils.maxWidth.sm} {
    font-size: 14px;
  }
`

export const ScrollMarginSection = styled.div`
  scroll-margin-top: 95px;
`

export const PartnerScrollMarginSection = styled(ScrollMarginSection)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
